
import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import "../../assets/css/Loader.css";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Select from "react-select";
import styled from "styled-components";
import ActionsDropdown from "../ActionsDropdown";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { format } from "date-fns";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(odd) {
    background-color: #f2f2f2; /* Light gray for even rows */
  }

  tr:nth-child(even) {
    background-color: #ffffff; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function Contact_leads() {
  const [responseData, setResponseData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [ispreviewshowModal, setpreviewShowModal] = useState(false);

  // const [isUpdatescheduleShowModal, setUpdatescheduleShowModal] =
  //   useState(false);
  const [responsesource, setResponsesource] = useState([]);
  const [responsepurpose, setResponsepurpose] = useState([]);
  const [category, setcategory] = useState([]);
  const [responseDatas, setResponseDatas] = useState([]);
  const [selected_category, setselected_category] = useState("");



  const [staff, setstaff] = useState("");
  const [role_id, setroleid] = useState("");

  const [previllages, setprevillages] = useState({});

  const [addData, setAddData] = useState({
    idlocal: "",
    visitor_staff: "",
    mobile_no: "",
    email: "",
    department: "",
    designation: "",
    college_name: "",
    visit_date: "",
    college_location: "",
    notes: "",

    last_visit_date: "",
    status: "",
    count: "",
    next_visit_date: "",
    purpose: ""


  });

  const [updateData, setUpdateData] = useState({
    name: "",
    visitor_staff: "",
    mobile_no: "",
    email: "",
    department: "",
    designation: "",
    college_name: "",
    visit_date: "",
    college_location: "",
    notes: "",


    last_visit_date: "",
    status: "",
    count: "",
    next_visit_date: "",
    purpose: ""
  });

  const [updateDataschedule, setUpdateDataschedule] = useState({
    name: "",
    visitor_staff: "",
    mobile_no: "",
    email: "",
    department: "",
    designation: "",
    college_name: "",
    visit_date: "",
    college_location: "",
    notes: "",


    last_visit_date: "",
    status: "",
    count: "",
    next_visit_date: "",
    purpose: ""
  });

  useEffect(() => {
    fetchData();
    gettoken();
    fetch();
    fetchDa();
    Enquirypurpose();
    fetchDatag();
    getprevillages();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl + "/update_lead_with_empid", {
        params: { data: localStorage.getItem("branch_id") },
      });
      console.log("Response from server conatct :", response.data);
      console.log("Response from server:12345", response.data[0]?.course_id);

      if (response && response.status === 200) {
        setTimeout(() => {
          setLoading(false);
        }, 300);
      }



      setResponseData(response.data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchDatag = async () => {
    try {
      const response = await axios.get(apiUrl + "/staff");
      console.log("Response from server:", response.data);

      setstaff(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchDa = async () => {
    try {
      const responsesources = await axios.get(apiUrl + "/source_type");
      console.log("Response from Source Type:", responsesources.data);
      setResponsesource(responsesources.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const Enquirypurpose = async () => {
    try {
      const responsepurposes = await axios.get(apiUrl + "/enquiry_purpose");
      console.log("Response from Enquiry purpose:", responsepurposes.data);

      setResponsepurpose(responsepurposes.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetch = async () => {
    try {
      const response = await axios.get(apiUrl + "/category_list");
      console.log("Response from server:", response.data);
      console.log("Response from category list :", category);
      setcategory(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const gettoken = async () => {
    const token = localStorage.getItem("token");
    // console.log("the toekn in the localStorage is : ",token);
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      // setResponseData(response.data);

      console.log("The role id is : ", response.data.detail.rolename);
      setroleid(response.data.detail.rolename);
      console.log("the role_id is : ", role_id);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      // getpages();

      if (id) {
        // try {
        //   const response = await axios.get(apiUrl + `/role_2/${id}`);
        //   console.log("the reponse list in brach is : ", response.data.modules);
        //   const modules = response.data.modules;
        //   const filtered_access = modules.filter(
        //     (item) => item.name == "Branch"
        //   );
        //   console.log("the modules is : ", filtered_access[0].actions);
        //   setprevillages(filtered_access[0].actions);
        //   console.log("the assigned previllages is : ", previllages.add);
        // } catch (error) {
        //   console.error("Error fetching data:", error.message);
        // }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const username = localStorage.getItem("username");

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);

    const total_previlages = username.modules;

    const new_enquiry = total_previlages.find(
      (item) => item.name == "Contact Leads"
    );

    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions);
  };

  const handlesubmit = async (e) => {
    e.preventDefault();

    if (!validateFields()) {
      return;
    }

    try {
      setLoading(true);
      const formData = {
        name: idlocal,
        visitor_staff: addData.visitor_staff,
        mobile_no: addData.mobile_no,
        email: addData.email,
        department: addData.department,
        designation: addData.designation,
        college_name: addData.college_name,
        visit_date: addData.visit_date,
        college_location: addData.college_location,
        notes: addData.notes,
        count: 1,
        last_visit_date: addData.last_visit_date,
        status: addData.status,
        count: addData.count,
        next_visit_date: addData.next_visit_date,
        purpose: addData.purpose,
      };
      const response = await axios.post(apiUrl + "/contact_leads", formData);
      console.log("Updated:", response);
      setShowModal(false);
      toast.success("added successfully!");
      setAddData({
        name: "",
      });
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const [updateid, setUpdateId] = useState("");

  const handleUpdate = (_id, data) => {
    if (previllages.edit || previllages.all) {
      setUpdateId(_id);
      console.log(" the data to updata   onclick data   ", data);
      console.log(" the data to updata   onclick course id   ", data.course_id);
      setUpdateShowModal(true);
      setUpdateData({
        name: data.name,
        visitor_staff: data.visitor_staff,
        mobile_no: data.mobile_no,
        email: data.email,
        department: data.department,
        designation: data.designation,
        college_name: data.college_name,
        visit_date: data.visit_date,
        college_location: data.college_location,
        notes: data.notes,

        last_visit_date: data.last_visit_date,
        status: data.status,
        count: data.count,
        next_visit_date: data.next_visit_date,
        purpose: data.purpose,
      });

      // updateData.course_id = "00187"

      console.log(" the data to updata   onclick   12", updateData.course_id);
    } else {
      toast.error("You don't have the permission");
    }
  };



  const handlepreview = (_id, data) => {

    setUpdateId(_id);
    console.log(" the data to updata   onclick data   ", data);
    console.log(" the data to updata   onclick course id   ", data.course_id);
    setpreviewShowModal(true);
    setUpdateData({
      name: data.name,
      visitor_staff: data.visitor_staff,
      mobile_no: data.mobile_no,
      email: data.email,
      department: data.department,
      designation: data.designation,
      college_name: data.college_name,
      visit_date: data.visit_date,
      college_location: data.college_location,
      notes: data.notes,

      last_visit_date: data.last_visit_date,
      status: data.status,
      count: data.count,
      next_visit_date: data.next_visit_date,
      purpose: data.purpose,

    });

    // updateData.course_id = "00187"

    console.log(" the data to updata   onclick   12", updateData.course_id);

  };




  // schedule update data
  const [updateidschedule, setUpdateIdschedule] = useState("");

  const handlescheduleUpdate = (_id, data) => {
    setUpdateIdschedule(_id);
    console.log(" the data to updata", data);

    const courses = responseDatas.find(
      (item) => item.course_name === data.Prefered_course
    );
    console.log("the courserr12", courses);
    if (courses) {
      const coursedata = courses.category_list;
      console.log("the courserr12", courses);
      console.log("the course category_list", coursedata);

      // Set category data to state
      setUpdateDataschedule((prevData) => ({
        ...prevData,
        category: coursedata,
      }));

      setUpdateDataschedule((prevData) => ({
        ...prevData, // Spread the previous state
        course_id: updateDataschedule.Prefered_course, // Update only the course_id field
      }));
    } else {
      console.log("No matching course found for Prefered_course.");
    }

    console.log("filterUpdateData___category ", updateDataschedule.category);

    // setUpdatescheduleShowModal(true);
    setUpdateDataschedule({
      name: idlocal,
      visitor_staff: data.visitor_staff,
      mobile_no: data.mobile_no,
      email: data.email,
      department: data.department,
      designation: data.designation,
      college_name: data.college_name,
      visit_date: data.visit_date,
      college_location: data.college_location,
      notes: data.notes,


      last_visit_date: data.last_visit_date,
      status: data.status,
      count: data.count,
      next_visit_date: data.next_visit_date,
      purpose: data.purpose,
    });
  };

  // Helper function to format ISO date to YYYY-MM-DD
  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };



  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };

  const [clickcount, setClickCount] = useState(1);

  // const handleupdatesubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     // Increment the count before making the update
  //     const updatedClickCount = clickcount + 1;

  //     setLoading(true);
  //     const formData = {
  //       name: idlocal,
  //       visitor_staff: updateData.visitor_staff,
  //       mobile_no: updateData.mobile_no,
  //       email: updateData.email,
  //       department: updateData.department,
  //       designation: updateData.designation,
  //       college_name: updateData.college_name,
  //       visit_date: updateData.visit_date,
  //       college_location: updateData.college_location,
  //       notes: updateData.notes,
  //       last_visit_date: updateData.last_visit_date,
  //       status: updateData.status,
  //       count: updatedClickCount, // Send the incremented count
  //       next_visit_date: updateData.next_visit_date,
  //       purpose: updateData.purpose,
  //     };
  //     console.log("The update submit data", formData);

  //     const response = await axios.put(apiUrl + `/contact_leads/${updateid}`, formData);
  //     console.log("Response for update", response);

  //     // After a successful update, set the new count value
  //     setClickCount(updatedClickCount);

  //     setUpdateShowModal(false);
  //     toast.success("Update successfully!");
  //     setTimeout(() => {
  //       setLoading(false);
  //     }, 1000);
  //     fetchData();
  //   } catch (error) {
  //     console.error("Error updating data:", error.message);
  //   }
  // };


  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      // let clickcount = "1";  // Let's assume this is the initial value.
      // Increment the count before making the update
      // const updatedClickCount =  parseInt(clickcount) + 1;
      const ss = updateData.count == undefined ? 1 : updateData.count
      const updatedClickCount = isNaN(parseInt(clickcount)) ? 0 : ss + 1;

      setLoading(true);
      const formData = {
        name: idlocal,
        visitor_staff: updateData.visitor_staff,
        mobile_no: updateData.mobile_no,
        email: updateData.email,
        department: updateData.department,
        designation: updateData.designation,
        college_name: updateData.college_name,
        visit_date: updateData.visit_date,
        college_location: updateData.college_location,
        notes: updateData.notes,
        last_visit_date: updateData.last_visit_date,
        status: updateData.status,
        count: updatedClickCount, // Send the incremented count
        next_visit_date: updateData.next_visit_date,
        purpose: updateData.purpose,
      };
      console.log("The update submit data", formData);

      const response = await axios.put(apiUrl + `/contact_leads/${updateid}`, formData);
      console.log("Response for update", response);

      // After a successful update, set the new count value
      // setClickCount(updatedClickCount);

      setUpdateShowModal(false);
      toast.success("Update successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };



  // const handleupdatesubmit = async (e) => {
  //   e.preventDefault();
  //   try {

  //     setLoading(true);
  //     const formData = {
  //       name: idlocal,
  //       visitor_staff: updateData.visitor_staff,
  //       mobile_no: updateData.mobile_no,
  //       email: updateData.email,
  //       department: updateData.department,
  //       designation: updateData.designation,
  //       college_name: updateData.college_name,
  //       visit_date: updateData.visit_date,
  //       college_location: updateData.college_location,
  //       notes: updateData.notes,



  //     last_visit_date: updateData.last_visit_date,
  //     status: updateData.status,
  //     count: clickcount,
  //     next_visit_date: updateData.next_visit_date,
  //     purpose: updateData.purpose,
  //     };
  //     console.log("the update submit data", formData);
  //     const response = await axios.put(
  //       apiUrl + `/contact_leads/${updateid}`,
  //       formData

  //     );
  //     console.log("response for update", response);
  //     setUpdateShowModal(false);
  //     toast.success("Update successfully!");
  //     setTimeout(() => {
  //       setLoading(false);
  //     }, 1000);
  //     fetchData();
  //   } catch (error) {
  //     console.error("Error updating data:", error.message);
  //   }
  // };

  // schedule

  const handleupdatesubmitschedule = async (e) => {
    e.preventDefault();

    setUpdateDataschedule((prevData) => ({
      ...prevData, // Spread the previous state
      course_id: updateDataschedule.course_id, // Update only the course_id field
    }));

    try {
      const formData = {
        name: idlocal,
        visitor_staff: updateDataschedule.visitor_staff,
        mobile_no: updateDataschedule.mobile_no,
        email: updateDataschedule.email,
        department: updateDataschedule.department,
        designation: updateDataschedule.designation,
        college_name: updateDataschedule.college_name,
        visit_date: updateDataschedule.visit_date,
        college_location: updateDataschedule.college_location,
        notes: updateDataschedule.notes,


        last_visit_date: updateDataschedule.last_visit_date,
        status: updateDataschedule.status,
        count: updateDataschedule.count,
        next_visit_date: updateDataschedule.next_visit_date,
        purpose: updateDataschedule.purpose,
      };
      console.log("the update schedule  submit data", formData);
      const response = await axios.post(apiUrl + `/`, formData);
      console.log("response for update", response);
      // setUpdatescheduleShowModal(false);
      toast.success("Schedule post successfully!");

      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      const response = await axios.delete(
        apiUrl + `/contact_leads/${getdeleteid}`
      );
      console.log("delete data ", response);
      toast.error("Delete successfully!");
      setDeleteShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");

  const handleOpenModal = (_id, name) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the name", name);
      setdeleteid(_id);
      setdeletename(name);
      setDeleteShowModals(true);
    } else {
      toast.error("You don't have the permission");
    }
  };



  // ///////////////////////////////////////////////////////////////////
  const handleAdditionalChange = async (e) => {
    const selectcategory = e.target.value; // Get the selected value from the dropdown

    setselected_category(e.target.value);

    fetchDatas_2(e.target.value);
    console.log(
      "Additional change function called with value:",
      selectcategory
    );
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  const fetchDatas = async (selected_category_2) => {
    try {
      const response = await axios.get(apiUrl + "/course");
      console.log("Response from server:123", response.data);
      console.log("Response from category list :", category);
      console.log("the selected_category is : ", selected_category_2);

      setResponseDatas(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchDatas_2 = async (selected_category_2) => {
    try {
      const response = await axios.get(
        apiUrl + "/category_course/" + selected_category_2
      );
      console.log("Response from server:", response.data);
      if (response && response.data) {
        const data = response.data;

        setResponseDatas(data);
      } else {
        console.error("No data received from server.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  function handleChangeSatus(e) {
    const course = responseDatas.filter(
      (item, index) => item.course_id == e.target.value
    );
    console.log(course, "course---");
    setAddData({
      ...addData,
      course_id: e.target.value,
      selectcourse: course[0]?.course_name || "Course Not Found", // Fallback if no course is found
    });
  }

  const [selectedCourse, setSelectedCourse] = useState(
    updateData.Prefered_course || ""
  );

  const [selectedCoursed, setSelectedCoursed] = useState(
    updateDataschedule.Prefered_course || ""
  );

  // Handle the change event

  // ////////////////////////////////

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
    setUpdateData({ ...updateData, Prefered_course: event.target.value });
  };

  const handleCourseChangedd = (e) => {
    setSelectedCoursed(e.target.value);
    setUpdateDataschedule({
      ...updateDataschedule,
      Prefered_course: e.target.value,
    });
  };

  const handleStaffChange = (e) => {
    setAddData({ ...addData, visitor_staff: e.target.value });
    setUpdateData({ ...updateData, visitor_staff: e.target.value });
  };
  const [idlocal, setlocalid] = useState([]);

  useEffect(() => {
    fetchData();
    const id_local = localStorage.getItem("username");
    setlocalid(id_local);
  }, []);

  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
    setAddData({ visit_date: currentDate });
  }, []);

  const [errors, setErrors] = useState({});

  const validateFields = () => {
    let tempErrors = {};
    let isValid = true;

    if (!addData.visitor_staff) {
      tempErrors.visitor_staff = "visitor staff is required.";
      isValid = false;
    }

    if (!addData.mobile_no) {
      tempErrors.mobile_no = "Mobile is required.";
      isValid = false;
    }

    if (!/^\d{10}$/.test(addData.mobile_no)) {
      tempErrors.mobile_no = "Mobile number must be 10 digits.";
      isValid = false;
    }

    if (!addData.email) {
      tempErrors.email = "Email is required.";
      isValid = false;
    }
    if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(addData.email)
    ) {
      tempErrors.email = "Please enter a valid email address.";
      isValid = false;
    }

    if (!addData.department) {
      tempErrors.department = "Department is required.";
      isValid = false;
    }

    if (!addData.designation) {
      tempErrors.designation = "Designation is required.";
      isValid = false;
    }

    if (!addData.college_name) {
      tempErrors.college_name = "college name is required.";
      isValid = false;
    }

    if (!addData.visit_date) {
      tempErrors.visit_date = "Visit_date is required.";
      isValid = false;
    }

    if (!addData.college_location) {
      tempErrors.college_location = "College location is required.";
      isValid = false;
    }

    if (!addData.notes) {
      tempErrors.notes = "Notes is required.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const [loading, setLoading] = useState(false);


  // the pagination  end ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // const createPagination = () => {
  //   let liTag = [];

  //   // Previous Page Button
  //   liTag.push(
  //     <li
  //       className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
  //       key="prev"
  //     >
  //       <button
  //         className="page-link"
  //         onClick={() => canPreviousPage && gotoPage(state.pageIndex - 1)}
  //         disabled={!canPreviousPage}
  //       >
  //         <FaAngleLeft /> Prev
  //       </button>
  //     </li>
  //   );

  //   // Page Numbers
  //   for (let plength = 1; plength <= pageCount; plength++) {
  //     liTag.push(
  //       <li
  //         key={plength}
  //         className={`page-item ${
  //           plength === state.pageIndex + 1 ? "active" : ""
  //         }`}
  //       >
  //         <button
  //           className="page-link"
  //           onClick={() => gotoPage(plength - 1)} // 0-indexed
  //         >
  //           {plength}
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Next Page Button
  //   liTag.push(
  //     <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
  //       <button
  //         className="page-link"
  //         onClick={() => canNextPage && gotoPage(state.pageIndex + 1)}
  //         disabled={!canNextPage}
  //       >
  //         Next <FaAngleRight />
  //       </button>
  //     </li>
  //   );

  //   return liTag;
  // };

  // const createPagination = () => {
  //   let liTag = [];
  //   let totalPages = pageCount; // Total pages
  //   let currentPage = state.pageIndex;
  //   let active;

  //   // Previous Page Button
  //   liTag.push(
  //     <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
  //       <button
  //         className="page-link"
  //         onClick={() => gotoPage(currentPage - 1)}
  //         disabled={!canPreviousPage}
  //       >
  //         <FaAngleLeft /> Prev
  //       </button>
  //     </li>
  //   );

  //   // Always show first page
  //   if (totalPages > 1) {
  //     liTag.push(
  //       <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
  //         <button className="page-link" onClick={() => gotoPage(0)}>
  //           1
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Show second page if total pages > 2
  //   if (totalPages > 2) {
  //     liTag.push(
  //       <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
  //         <button className="page-link" onClick={() => gotoPage(1)}>
  //           2
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Add "..." before current page group
  //   if (currentPage > 3) {
  //     liTag.push(
  //       <li className="page-item disabled" key="dot-prev">
  //         <span className="page-link">...</span>
  //       </li>
  //     );
  //   }

  //   // Show 3 pages around current page
  //   for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
  //     active = currentPage === i ? "active" : "";
  //     liTag.push(
  //       <li className={`page-item ${active}`} key={i}>
  //         <button className="page-link" onClick={() => gotoPage(i)}>
  //           {i + 1}
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Add "..." after current page group
  //   if (currentPage < totalPages - 4) {
  //     liTag.push(
  //       <li className="page-item disabled" key="dot-next">
  //         <span className="page-link">...</span>
  //       </li>
  //     );
  //   }

  //   // Always show last two pages if totalPages > 2
  //   if (totalPages > 2) {
  //     liTag.push(
  //       <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
  //         <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
  //           {totalPages - 1}
  //         </button>
  //       </li>
  //     );
  //   }

  //   if (totalPages > 1) {
  //     liTag.push(
  //       <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
  //         <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
  //           {totalPages}
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Next Page Button
  //   liTag.push(
  //     <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
  //       <button
  //         className="page-link"
  //         onClick={() => gotoPage(currentPage + 1)}
  //         disabled={!canNextPage}
  //       >
  //         Next <FaAngleRight />
  //       </button>
  //     </li>
  //   );

  //   return liTag;
  // };  


  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  const data = useMemo(() => {
    return responseData.map((item, index) => ({
      _id: item._id,
      visitor_staff: item.visitor_staff,
      mobile_no: item.mobile_no,
      college_name: item.college_name,
      visit_date: item.visit_date,
      name: item.name,
      college_location: item.college_location,
      department: item.department,
      designation: item.designation,
      email: item.email,
      empid: item.empid,
      notes: item.notes,
      serialNo: index + 1, // Correct serial number assignment


      last_visit_date: item.last_visit_date,
      status: item.status,
      count: item.count,
      next_visit_date: item.next_visit_date,
      purpose: item.purpose,

    }));
  }, [responseData]);


  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "serialNo",
        disableFilters: true,

      },
      {
        Header: "Faculty Name",
        accessor: "visitor_staff",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Mobile",
        accessor: "mobile_no",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      }, {
        Header: "College Name",
        accessor: "college_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      }, {
        Header: "Visit Date",
        accessor: (row) => {
          const date = new Date(row.visit_date);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        },
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      }

      , {
        Header: "Staff",
        accessor: "name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-11">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="#" className="text-secondary dashBoard_text">
                <b>Leads / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>Contact Leads</b>
              </Link>
            </div>
          </div>
        </div>
        {/* Table */}

        {/* ------------ search and per page ----------------------------*/}



        <div className="mb-1 mt-3">
          <div className="row">
            <div className="d-flex col-lg-3">
              <h5 className="mt-1">Contact Leads</h5>
              <div className="mx-3">
                {previllages.add && (
                  <button
                    className="btn btn-success add mx-3"
                    onClick={() => setShowModal(true)}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-1"></div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">
              <form className="me-5">
                <div className="relative">
                  <input
                    className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                    placeholder="Search ..."
                    type="search"
                    value={state.globalFilter || ""} // Use the globalFilter value
                    onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                  />
                </div>
              </form>
              {/* </div> */}


              {/* <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="d-flex ms-4">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'All') {
                        setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) =>
                        handleUpdate(id, row)
                      }
                      onDelete={(id, row) =>
                        handleOpenModal(id, row.name)
                      }
                      onInfo={(id, row) =>
                        handlepreview(id, row)
                      }
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {/* Modal for adding a new user */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Add Contact Leads</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={idlocal || ""} // Use an empty string if idlocal is null or undefined
                      onChange={(e) =>
                        setAddData({ ...addData, idlocal: e.target.value })
                      }
                      disabled
                      required
                    />
                    <label className={idlocal ? "filled" : ""}>Staff</label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.visitor_staff}
                      onChange={(e) =>
                        setAddData({
                          ...addData,
                          visitor_staff: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={addData.visitor_staff ? "filled" : ""}>
                      Faculty Name
                    </label>

                    {errors.visitor_staff && (
                      <div className="error-text">{errors.visitor_staff}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.mobile_no}
                      onChange={(e) =>
                        setAddData({ ...addData, mobile_no: e.target.value })
                      }
                      required
                    />
                    <label className={addData.mobile_no ? "filled" : ""}>
                      Mobile No
                    </label>
                    {errors.mobile_no && (
                      <div className="error-text">{errors.mobile_no}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="Email"
                      placeholder=""
                      value={addData.email}
                      onChange={(e) =>
                        setAddData({ ...addData, email: e.target.value })
                      }
                      required
                    />
                    <label className={addData.email ? "filled" : ""}>
                      Email
                    </label>
                    {errors.email && (
                      <div className="error-text">{errors.email}</div>
                    )}
                  </div>



                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={addData.visit_date}
                      onChange={(e) =>
                        setAddData({ ...addData, visit_date: e.target.value })
                      }
                      required
                    />
                    <label className={addData.visit_date ? "filled" : ""}>
                      Visit Date
                    </label>
                  </div>
                  {errors.visit_date && (
                    <div className="error-text">{errors.visit_date}</div>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.department}
                    onChange={(e) =>
                      setAddData({
                        ...addData,
                        department: e.target.value,
                      })
                    }
                    required
                  />
                  <label className={addData.department ? "filled" : ""}>
                    Department
                  </label>
                  {errors.department && (
                    <div className="error-text">{errors.department}</div>
                  )}
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.designation}
                    onChange={(e) =>
                      setAddData({
                        ...addData,
                        designation: e.target.value,
                      })
                    }
                    required
                  />
                  <label className={addData.designation ? "filled" : ""}>
                    Designation
                  </label>
                  {errors.designation && (
                    <div className="error-text">{errors.designation}</div>
                  )}
                </div>

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.college_name}
                    onChange={(e) =>
                      setAddData({ ...addData, college_name: e.target.value })
                    }
                    required
                  />
                  <label className={addData.college_name ? "filled" : ""}>
                    College Code & Name
                  </label>
                  {errors.college_name && (
                    <div className="error-text">{errors.college_name}</div>
                  )}
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.college_location}
                    onChange={(e) =>
                      setAddData({
                        ...addData,
                        college_location: e.target.value,
                      })
                    }
                    required
                  />
                  <label className={addData.college_location ? "filled" : ""}>
                    College Location
                  </label>
                  {errors.college_location && (
                    <div className="error-text">{errors.college_location}</div>
                  )}
                </div>
                {errors.notes && (
                  <div className="error-text">{errors.notes}</div>
                )}
              </div>
              <div className="floating-label col-lg-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.notes}
                  onChange={(e) =>
                    setAddData({
                      ...addData,
                      notes: e.target.value,
                    })
                  }
                  required
                />
                <label className={addData.notes ? "filled" : ""}>
                  Remarks
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handlesubmit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          // className="mod"
          show={isUpdateshowModal}
          onHide={() => setUpdateShowModal(false)}
          size="lg"
          dialogClassName="custom-modal-height"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Update Contact Leads</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          name: e.target.value,
                        })
                      }
                      required
                      disabled
                    />

                    <label className={updateData.name ? "filled" : ""}>Staff</label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.visitor_staff}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          visitor_staff: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.visitor_staff ? "filled" : ""}>
                      Faculty Name
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.mobile_no}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          mobile_no: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.mobile_no ? "filled" : ""}>
                      Mobile No
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.email}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, email: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.email ? "filled" : ""}>
                      Email
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={
                        updateData.visit_date
                          ? formatDatefitching(updateData.visit_date)
                          : ""
                      }
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          visit_date: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.visit_date ? "filled" : ""}>
                      Visit Date
                    </label>
                  </div>




                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.department}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          department: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.department ? "filled" : ""}>
                      Department
                    </label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.designation}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          designation: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.designation ? "filled" : ""}>
                      Designation
                    </label>
                  </div>






                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.college_name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          college_name: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.college_name ? "filled" : ""}>
                      College Code & Name
                    </label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.college_location}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          college_location: e.target.value,
                        })
                      }
                      required
                    />
                    <label
                      className={updateData.college_location ? "filled" : ""}
                    >
                      College Location
                    </label>
                  </div>

                  {/* =======================New Field update========================== */}
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="Date"
                      placeholder=""
                      // value={updateData.last_visit_date}
                      value={
                        updateData.last_visit_date
                          ? formatDatefitching(updateData.visit_date)
                          : ""
                      }
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          last_visit_date: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.last_visit_date ? "filled" : ""}>
                      Last Visit Date
                    </label>
                  </div>





                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.status}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          status: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.status ? "filled" : ""}>
                      Status
                    </label>
                  </div>




                  {console.log(updateData, "the data is are")}
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"

                      value={updateData.count == undefined ? 1 : updateData.count}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          count: e.target.value,
                        })
                      }
                      required
                    />
                    <label >
                      Count
                    </label>
                  </div>



                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={updateData.next_visit_date}

                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          next_visit_date: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.next_visit_date ? "filled" : ""}>
                      Next Visit Date
                    </label>
                  </div>
                </div>
              </div>
              <div className="floating-label col-lg-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.notes}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      notes: e.target.value,
                    })
                  }
                  required
                />
                <label className={updateData.notes ? "filled" : ""}>
                  Remarks
                </label>
              </div>
              <div className="floating-label col-12">
                <textarea
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.purpose}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      purpose: e.target.value,
                    })
                  }
                  required
                />
                <label className={updateData.purpose ? "filled" : ""}>
                  Purpose
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={

                handleupdatesubmit}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>





        <Modal
          show={ispreviewshowModal}
          onHide={() => setpreviewShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">preview Contact Leads</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          name: e.target.value,
                        })
                      }
                      required
                      disabled
                    />

                    <label className={updateData.name ? "filled" : ""}>Staff</label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      disabled
                      value={updateData.visitor_staff}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          visitor_staff: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.visitor_staff ? "filled" : ""}>
                      Faculty Name
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      disabled
                      value={updateData.mobile_no}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          mobile_no: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.mobile_no ? "filled" : ""}>
                      Mobile No
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      disabled
                      value={updateData.email}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, email: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.email ? "filled" : ""}>
                      Email
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      disabled
                      placeholder=""
                      value={
                        updateData.visit_date
                          ? formatDatefitching(updateData.visit_date)
                          : ""
                      }
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          visit_date: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.visit_date ? "filled" : ""}>
                      Visit Date
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      disabled
                      value={updateData.department}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          department: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.department ? "filled" : ""}>
                      Department
                    </label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      disabled
                      value={updateData.designation}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          designation: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.designation ? "filled" : ""}>
                      Designation
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      disabled
                      value={updateData.college_name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          college_name: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.college_name ? "filled" : ""}>
                      College Code & Name
                    </label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      disabled
                      value={updateData.college_location}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          college_location: e.target.value,
                        })
                      }
                      required
                    />
                    <label
                      className={updateData.college_location ? "filled" : ""}
                    >
                      College Location
                    </label>
                  </div>
                </div>
              </div>
              <div className="floating-label col-lg-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  disabled
                  value={updateData.notes}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      notes: e.target.value,
                    })
                  }
                  required
                />
                <label className={updateData.notes ? "filled" : ""}>
                  Remarks
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setpreviewShowModal(false)}
            >
              Cancel
            </Button>

          </Modal.Footer>
        </Modal>

        {/* ----------------delete */}

        <Modal
          className="modal"
          show={deleteShowModals}
          onHide={handleCloseModal}
        >
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1">Name :</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
        {/* _------------------------------pagination button -------------------------------- */}

        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {state.pageIndex + 1} of {pageCount}
              </span>
            </div>
            <div className="col-lg-5">
              <div className="mt-3 pb-5">
                <nav>
                  <ul className="pagination justify-content-center">
                    {createPagination()} {/* Pagination buttons */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------------------------------end ---------------------------------- */}
      </div>
    </>
  );
}

export default Contact_leads;

